import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {ProductTopDesktopPanel} from 'modules/products/components/ProductTopDesktopPanel';
import {FC} from 'react';
import {ProductStickyHeaderPageName} from 'modules/product-card/constants';
import {useIsPrive} from 'core/hooks/useIsPrive';

interface IProps {
    page?: ProductStickyHeaderPageName;
}

const {Product} = ProductStickyHeaderPageName;

export const ProductTopDesktopPanelContainer: FC<IProps> = ({page = Product}) => {
    const productData = useAppSelector(selectProductData);
    const {canBuy, canReserve} = productData || {};
    const isPrive = useIsPrive();

    if (!canBuy && !canReserve && isPrive) {
        return null;
    }

    return <ProductTopDesktopPanel page={page} />;
};
